<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item label="电表表号：">
              <el-input v-model="detailData.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <template v-if="dialogType == 'rechargeDetail'">
            <el-col span="12">
              <el-form-item label="充值金额：">
                <el-input v-model="detailData.importBalance" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="实际充值时间：">
                <el-input v-model="detailData.chargeOrReadTime" disabled></el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-else-if="dialogType == 'withholdDetail'">
            <el-col span="12">
              <el-form-item label="扣缴金额：">
                <el-input v-model="detailData.importBalance" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="实际抄表时间：">
                <el-input v-model="detailData.chargeOrReadTime" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="扣缴单价：">
                <el-input v-model="detailData.unitPrice" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="扣缴上期止码：">
                <el-input v-model="detailData.lastEndNum" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="扣缴当期止码：">
                <el-input v-model="detailData.endNum" disabled></el-input>
              </el-form-item>
            </el-col>
          </template>

          <el-col span="12">
            <el-form-item label="发生前余额：">
              <el-input v-model="detailData.beforeBalance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="发生后余额：">
              <el-input v-model="detailData.afterBalance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="操作时间：">
              <el-input v-model="detailData.operateTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="操作人：">
              <el-input v-model="detailData.operateMan" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { detailApi } from '@/api/electric-meter/electric-meter-bill';

export default {
  props: ['rowData', 'dialogType'],
  data() {
    return {
      detailData: {},
    };
  },
  created() {
    detailApi({
      id: this.rowData.id,
    }).then(({ data }) => {
      this.detailData = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
